import { SHOW_SECOND_STEP_AUTH_FORM } from '../actionTypes';
import { loginActions } from '../reducer';

export default (value) => loginActions[SHOW_SECOND_STEP_AUTH_FORM](value);
